import React from 'react';
import PropTypes from 'prop-types';
import s from './Text.scss';
/**
 * Text Component Used for loading the BTF/ATF content on the Page.
 * Sample JSON needed for this will be : {"tn":"btfcontent","des":"sample btf content description"}
 * @param {*} props
 */
const Text = props => {
  const {
    text,
    className = '',
    hl,
    theme,
    background,
    isdangerouslySetInnerHTML,
    btfId,
  } = props;

  const smalltext = `
      <p>Questions marked with red asterisk (*) are mandatory to answer</p>
      <p>Legal information is not legal advice, read the disclaimer. The information provided on this site is not legal advice, does not constitute a lawyer referral service, and no attorney-client or confidential relationship is or will be formed by use of the site.</p>
    `;

  return className === 'disclamer' ? (
    <div className={`${s.btfcontent} ${s[background]} ${s[className]}`}>
      <div className="contentwrapper">
        <h4>DISCLAIMER:</h4>
        <div
          className={`${s.text} ${s[className]} ${s[theme]}`}
          dangerouslySetInnerHTML={{ __html: smalltext }}
        />
      </div>
    </div>
  ) : (
    <div className={`${s.btfcontent} ${s[background]}`} id={btfId || ''}>
      <div className="contentwrapper">
        {hl ? <h1>{hl}</h1> : null}

        {isdangerouslySetInnerHTML ? (
          <div
            className={`${s.text} ${className} ${s[theme]}`}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ) : (
          <div className={`${s.text} ${className} ${s[theme]}`}>{text}</div>
        )}
      </div>
    </div>
  );
};
Text.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  hl: PropTypes.string,
  theme: PropTypes.string,
  background: PropTypes.string,
  isdangerouslySetInnerHTML: PropTypes.bool,
  btfId: PropTypes.string,
};
Text.defaultProps = {
  text: '',
  className: '',
  hl: undefined,
  theme: 'column',
  background: 'coloured',
  isdangerouslySetInnerHTML: false,
  btfId: '',
};
export default Text;
